import { render } from "./FormDataList.vue?vue&type=template&id=a2d46d6e"
import script from "./FormDataList.vue?vue&type=script&lang=js"
export * from "./FormDataList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aquis/vue-modules/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__